import { PermissionResource, permissionResource } from '@witkac/kartamiejska-resources';
import { PermissionObjectType } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł uprawnień
 *
 * @export
 * @class PermissionsModule
 * @extends {EntityModule<PermissionObjectType, PermissionResource>}
 */
export class PermissionsModule extends EntityModule<PermissionObjectType, PermissionResource> {
  constructor() {
    super(permissionResource);
  }
}

export default new PermissionsModule();
